import React, { useState, useEffect, useRef } from 'react';
import styles from './styles.module.css';
import { ReactSVG } from 'react-svg';
import { Icons } from '@/assets';

const SearchContainer = ({
  setContainerName,
  setPage,
  width,
  placeholder,
  className,
  autoFocus = false,
}) => {
  const [query, setQuery] = useState('');
  const [debouncedQuery, setDebouncedQuery] = useState('');
  const inputRef = useRef(null);

  useEffect(() => {
    if (autoFocus && inputRef.current) {
      const timer = setTimeout(() => {
        if (inputRef.current) {
          inputRef.current.focus();
        }
      }, 100);

      return () => clearTimeout(timer);
    }
  }, [autoFocus]);

  // Debounce logic
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedQuery(query);
    }, 500); // 500ms delay

    return () => {
      clearTimeout(handler);
    };
  }, [query]);

  // API call when debounced query changes
  useEffect(() => {
    searchContainerNumber(debouncedQuery);
  }, [debouncedQuery]);

  const searchContainerNumber = (searchTerm) => {
    setContainerName(searchTerm);
    setPage && setPage(1);
  };

  return (
    <div
      className={`${styles.searchContainer} ${className}`}
      style={{ width: width }}>
      <ReactSVG
        src={Icons.searchIcon}
        className={styles.search}
        beforeInjection={(svg) => {
          svg.querySelectorAll('path').forEach((path) => {
            path.setAttribute('stroke', '#99A0AE');
          });
        }}
      />
      <input
        ref={inputRef}
        type="text"
        className={styles.inputsearch}
        placeholder={placeholder || 'Search Container Number...'}
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        autoComplete="off"
        data-form-type="search"
        name="search-container-input"
        id="search-container-input"
      />
    </div>
  );
};

export default SearchContainer;
